"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPM = void 0;
const gs_1 = require("@ivanlog/gs");
const StateLoading_1 = require("./states/StateLoading");
const StateContacts_1 = require("./states/StateContacts");
const StateMain_1 = require("./states/StateMain");
const StateAboutCompany_1 = require("./states/StateAboutCompany");
const State404_1 = require("./states/State404");
const StateArticlesInfo_1 = require("./states/StateArticlesInfo");
const StateArticlesNews_1 = require("./states/StateArticlesNews");
const StateArticlesSale_1 = require("./states/StateArticlesSale");
const StateProductsFavourites_1 = require("./states/StateProductsFavourites");
const StateHeadHunt_1 = require("./states/StateHeadHunt");
const StateLegalInfo_1 = require("./states/StateLegalInfo");
const StatePolitics_1 = require("./states/StatePolitics");
const StateCatalog_1 = require("./states/StateCatalog");
const StateProduct_1 = require("./states/StateProduct");
const StateSearch_1 = require("./states/StateSearch");
const FavoriteController_1 = require("./controllers/FavoriteController");
const SearchController_1 = require("../classes/appControllers/SearchController");
const StateCart_1 = require("./states/StateCart");
const CartController_1 = require("./controllers/CartController");
const StateOrderNew_1 = require("./states/StateOrderNew");
const StateProfile_1 = require("./states/StateProfile");
const App_1 = require("../classes/App");
const GUIControllerPM_1 = require("./controllers/GUIControllerPM");
const GUIController_1 = require("../classes/appControllers/GUIController");
const StateDocuments_1 = require("./states/StateDocuments");
const Helper_1 = require("../classes/Helper");
class AppPM extends App_1.App {
    static get GUI() { return this.Inst.gui; }
    static get Cart() { return this.Inst.cart; }
    constructor() {
        super();
        AppPM.Inst = this;
        gs_1.StateGS.State404Name = State404_1.State404.StateName;
        this.gui = new GUIControllerPM_1.GUIControllerPM(this);
        this.addInst(GUIControllerPM_1.GUIControllerPM, this.gui);
        this.addInst(GUIController_1.GUIController, this.gui);
        this.favorite = new FavoriteController_1.FavoriteController(this);
        this.addInst(FavoriteController_1.FavoriteController, this.favorite);
        this.search = new SearchController_1.SearchController(this);
        this.addInst(SearchController_1.SearchController, this.search);
        this.cart = new CartController_1.CartController(this);
        this.addInst(CartController_1.CartController, this.cart);
        this.gui.initialize();
        this.favorite.initialize();
        this.cart.initialize();
        this.search.initialize();
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateMain_1.StateMain);
            gs_1.StateGS.RegState(State404_1.State404);
            gs_1.StateGS.RegState(StateContacts_1.StateContacts);
            gs_1.StateGS.RegState(StateDocuments_1.StateDocuments);
            gs_1.StateGS.RegState(StateAboutCompany_1.StateAboutCompany);
            gs_1.StateGS.RegState(StateArticlesInfo_1.StateArticlesInfo);
            gs_1.StateGS.RegState(StateArticlesNews_1.StateArticlesNews);
            gs_1.StateGS.RegState(StateArticlesSale_1.StateArticlesSale);
            gs_1.StateGS.RegState(StateProductsFavourites_1.StateProductsFavourites);
            gs_1.StateGS.RegState(StateHeadHunt_1.StateHeadHunt);
            gs_1.StateGS.RegState(StateLegalInfo_1.StateLegalInfo);
            gs_1.StateGS.RegState(StatePolitics_1.StatePolitics);
            gs_1.StateGS.RegState(StateCatalog_1.StateCatalog);
            gs_1.StateGS.RegState(StateSearch_1.StateSearch);
            gs_1.StateGS.RegState(StateProduct_1.StateProduct);
            gs_1.StateGS.RegState(StateCart_1.StateCart);
            gs_1.StateGS.RegState(StateOrderNew_1.StateOrderNew);
            gs_1.StateGS.RegState(StateProfile_1.StateProfile);
            yield Helper_1.Helper.loadYandexMapAsync();
            yield this.auth.tryRefreshTokenAsync();
            gs_1.StateGS.DefaultStateName = StateMain_1.StateMain.StateName;
            this._checkCookies();
            let result = yield gs_1.StateGS.RunByUrl();
        });
    }
    _checkCookies() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!localStorage.getItem("cookies_confirm")) {
                yield this.gui.showOnlyOkMessage("Оставаясь на сайте, вы соглашаетесь на использование файлов куки и рекомендательных технологий - для того, чтобы сайт работал лучше.");
                localStorage.setItem("cookies_confirm", "1");
            }
        });
    }
}
exports.AppPM = AppPM;
AppPM.VERSION = "0.0.2";
//# sourceMappingURL=AppPM.js.map